import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReloadPageComponent } from './reload-page.component';

@NgModule({
    declarations: [ReloadPageComponent],
    imports: [
        CommonModule
    ],
    exports: [
        ReloadPageComponent
    ]
})
export class ReloadPageModule { }
